module.exports = __webpack_public_path__ + "static/media/icon-home-selected.06d41eff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/icon-home-selected.svg
// module id = 127
// module chunks = 0